import React, { useState, useEffect, useContext } from 'react';
import OnceFooter from "./../common/Footer/OnceFooter";
import { useParams } from 'react-router-dom';
import api, { WEB_BASE_URL } from './../../utils/api';
import { Button } from 'react-bootstrap';
import { numberFormat } from './../../utils/functions';
import { toast } from 'react-toastify';
import moment from "moment";
import 'moment/locale/th'
import _ from "lodash";
import Lightbox from 'react-image-lightbox';

export default function BookingImageOverview() {
  const { code } = useParams();
  const [currentMonth, setCurrentMonth] = useState(new Date())
  const [data, setData] = useState({})
  const [downloading, setDownloading] = useState(false)

  const [imageUrl, setImageUrl] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const { hotel, monthAndYearDisplay, monthAndYear, dayOfMonth, rooms, bookingItems, roomBlockDays, walkinBookingItems, walkinBlockDays, isWalkin } = data;

  const fetchData = () => {
    api.request('bookings/get-booking-overview-data', (data) => {
      if (data?.is_success) {
        setData(data);
      } else {
        setData({});
      }
    }, {
      date: moment(currentMonth).format('YYYY-MM-DD'),
      code: code,
    })
  }

  const fetchImage = () => {
    if (downloading) {
      return;
    }

    setDownloading(true)
    api.request('bookings/get-booking-overview-image', (data) => {
      setDownloading(false)
      if (data?.is_success) {
        setImageUrl(data.image);
        setIsOpen(true);
      } else {
        toast.error("ไม่สามารถดาวน์โหลดรูปภาพได้");
      }
    }, {
      date: moment(currentMonth).format('YYYY-MM-DD'),
      code: code,
    });
  };

  useEffect(() => {
    if (!currentMonth) {
      return;
    }
    fetchData()
  }, [currentMonth])

  useEffect(() => {
    if (!code) {
      return;
    }
    fetchData()
  }, [code])

  const sumBookingAndBlockdaysCount = (room_id) => {
    const roomBookings = bookingItems.filter(item => item.room_id === room_id) || []

    const bookingDays = roomBookings.reduce((acc, item) => {
      const startDate = moment(item.start_date);
      const endDate = moment(item.end_date);
      const days = [];
      for (let m = startDate; m.isSameOrBefore(endDate); m.add(1, 'days')) {
        if (moment(m).isSame(currentMonth, 'month')) {
          days.push(m.format("YYYY-MM-DD"));
        }
      }
      return acc.concat(days);
    }, []);



    const roomBlockDaysLength = roomBlockDays.filter(item => item.room_id === room_id && !bookingDays.includes(moment(item.date).format('YYYY-MM-DD')))?.length || 0;
    return bookingDays.length + roomBlockDaysLength;
  }

  const walkingBookingsLength = isWalkin ? walkinBookingItems?.length || 0 : 0;

  return (
    <>
      {!data?.is_success && <div className="text-center p-5">
        <h4 className="text-danger">ลิงค์ไม่ถูกต้อง</h4>
      </div>}
      {data?.is_success && <div className="text-center p-4 booking-image-overview-page" style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h3>Booking Overview</h3>
        <h3>{hotel.name_th}</h3>
        <div className="d-flex mb-3 align-items-center">
          <div className="overview-state-info" style={{ backgroundColor: '#90ee9061' }}></div><span className="text-black ms-2">Booked</span>
          <div className="overview-state-info ms-3" style={{ backgroundColor: '#ff00005e' }}></div><span className="text-black ms-2">Blocked</span>
          <div className="text-black text-end" style={{ flex: 1 }}>
            <div>Exported by ONCE IN MEMORY</div>
            <div>{`Latest update: ${moment().locale('th').format('DD/MM/YYYY HH:mm ')}`}</div>
          </div>
        </div>

        <div className="d-flex align-items-center mb-2">
          <Button
            variant="outline-success"
            className="btn btn-sm "
            onClick={() => setCurrentMonth(prev => moment(prev).subtract(1, 'months').toDate())}
          >
            &lt; Prev
          </Button>
          <h4 className="mb-0 px-3">{monthAndYearDisplay}</h4>
          <Button
            variant="outline-success"
            className="btn btn-sm "
            onClick={() => setCurrentMonth(prev => moment(prev).add(1, 'months').toDate())}
          >
            Next &gt;
          </Button>
          <div style={{ flex: 1 }} className="text-end d-none d-md-block">
            <Button
              variant="outline-danger"
              className="btn btn-sm "
              onClick={() => fetchImage()}
              disabled={downloading}
            >
              <i className="fal fa-download"></i> {downloading ? 'Downloading...' : 'Download Image'}
            </Button>
          </div>
        </div>
        <div className="text-start d-block d-md-none">
          <Button
            variant="outline-danger"
            className="btn btn-sm "
            onClick={() => fetchImage()}
            disabled={downloading}
          >
            <i className="fal fa-download"></i> {downloading ? 'Downloading...' : 'Download Image'}
          </Button>
        </div>
        {isOpen && imageUrl && (
          <Lightbox
            mainSrc={imageUrl}
            onCloseRequest={() => {
              setIsOpen(false);
              setImageUrl(null);
            }}
            imageTitle="แตะค้าง/คลิกขวาที่รูปเพื่อบันทึกลงเครื่อง"
            enableZoom={false}
            discourageDownloads={false}
            clickOutsideToClose={false}
          />
        )}
        <div className="booking-image-overview-table" style={{ overflowX: 'auto' }}>
          <table className="table table-bordered" style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#d3d3d37d' }}>
            <thead>
              <tr>
                <th style={{ width: '40px' }}>DAY</th>
                <th style={{ width: '40px' }}>DATE</th>
                {rooms.map((room, index) => {
                  return <th key={index} >{room.name_th}</th>
                })}

                {!!isWalkin && <th>CAMPING</th>}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: dayOfMonth }, (_, i) => i + 1).map((day, index) => {
                const currentdate = moment(`${monthAndYear}-${day < 10 ? `0${day}` : day}`).format("YYYY-MM-DD")
                const dayOfWeek = moment(currentdate).day()
                const dayName = moment(currentdate).locale('en').format('ddd')

                const walkinBookingItem = walkinBookingItems.find((b) => b.date === currentdate)
                const walkinBlockDay = walkinBlockDays.find((b) => b.date === currentdate)

                return <tr key={index}>
                  <td >{dayName}</td>
                  <td >
                    <div className="d-flex justify-content-center align-items-center">
                      {/* <div style={{ width: 10, height: 10, backgroundColor: color, borderRadius: '50%' }}></div> */}
                      <span>{day < 10 ? `0${day}` : day}</span>
                      {/* <span className="ms-2">{day < 10 ? `0${day}` : day}</span> */}
                    </div>
                  </td>
                  {rooms.map((room, index) => {
                    const bookingItem = bookingItems.find((b) => b.room_id === room.id && b.start_date <= currentdate && b.end_date >= currentdate)
                    const roomBlockDay = roomBlockDays.find((b) => b.room_id === room.id && b.date === currentdate)

                    return <td key={index} style={{ backgroundColor: !!bookingItem ? '#90ee9061' : (!!roomBlockDay ? '#ff00005e' : '') }}>
                      {!!bookingItem || !!roomBlockDay ? 'X' : ''}
                    </td>
                  })}
                  {!!isWalkin && <td style={{ backgroundColor: !!walkinBookingItem ? '#90ee9061' : (!!walkinBlockDay ? '#ff00005e' : '') }}>
                    {!!walkinBookingItem ? (walkinBookingItem.is_close_zone ? 'ALL' : Number(walkinBookingItem?.guest_summary || 0)) : (!!walkinBlockDay ? 'X' : '')}
                  </td>}
                </tr>
              })}
              <tr>
                <td colSpan={2}>จำนวนวัน</td>
                {rooms.map((room, index) => {
                  return <td key={index} >{room.name_th}</td>
                })}
                {!!isWalkin && <td>CAMPING</td>}
              </tr>
              <tr className="table-summary">
                <td colSpan={2} className="date-td">{numberFormat(dayOfMonth, true)}</td>
                {rooms.map((room, index) => {
                  const totalCount = sumBookingAndBlockdaysCount(room.id);
                  return <td className="booking-sum-td" key={index} >{numberFormat(totalCount, true)}</td>
                })}
                {!!isWalkin && <td className="booking-sum-td">{numberFormat(walkingBookingsLength || 0, true)}</td>}
              </tr>
            </tbody>
          </table>
        </div>
      </div>}
      <OnceFooter />
    </>
  );
}
